<template>
    <div :class="titleClass" @mouseover="hover = true" @mouseleave="hover = false">
      <!-- <i v-if="!isMenu" :class="iconClass" :style="itemColor"></i> -->
      <component v-if="!isMenu" v-bind:is="`icon-${svg}`" width="5em" :color="color"></component>
      <div :class="textClass">
        <i v-if="isMenu" :class="iconClass" :style="itemColor"></i>
        <span v-if="!isMenu || selected">
          {{ text }}
        </span>
      </div>
    </div>
</template>

<script>
import iconReceber from '@/components/icons/receber.vue'
import iconElaboracao from '@/components/icons/elaboracao.vue'
import iconMeus from '@/components/icons/meus.vue'
import iconSetor from '@/components/icons/setor.vue'
import iconReservados from '@/components/icons/reservados.vue'
import iconTramitados from '@/components/icons/tramitados.vue'
import iconBuscaGeral from '@/components/icons/busca-geral.vue'
import iconSPI from '@/components/icons/spi.vue'
import iconContatoExterno from '@/components/icons/contato-externo.vue'
import iconMensagem from '@/components/icons/mensagem.vue'
import iconAdmin from '@/components/icons/admin.vue'
import iconInativarEstrutura from '@/components/icons/inativarEstrutura.vue'

export default {
  components: {
    'icon-receber': iconReceber,
    'icon-elaboracao': iconElaboracao,
    'icon-meus': iconMeus,
    'icon-setor': iconSetor,
    'icon-reservados': iconReservados,
    'icon-tramitados': iconTramitados,
    'icon-busca-geral': iconBuscaGeral,
    'icon-spi': iconSPI,
    'icon-contato-externo': iconContatoExterno,
    'icon-mensagem': iconMensagem,
    'icon-admin': iconAdmin,
    'icon-inativar-strutura': iconInativarEstrutura
  },

  props: {
    icon: { required: true, type: String },
    title: { required: true, type: String },
    color: { required: false, type: String, default: '#0720E0' },
    svg: { required: false, type: String, default: 'receber' },
    isMenu: { required: true, type: Boolean },
    selected: { required: true, type: Boolean }
  },

  data () {
    return {
      text: '',
      hover: false
    }
  },

  created () {
    this.text = this.title
  },

  computed: {
    iconClass: function () {
      return `${this.icon} ${this.isMenu ? 'fa-1-5x' : 'fa-5x'}`
    },
    textClass: function () {
      return `${this.isMenu ? '' : 'h4'} text-md mt-1 mb-0 font-weight-bold text-uppercase`
    },
    titleClass: function () {
      return ''
    },
    itemColor: function () {
      return {
        color: this.selected ? this.color : this.hover ? this.color : '#757575'
      }
    }
  },

  watch: {
    selected (newValue, oldValue) {
      this.text = ''
      setTimeout(() => {
        this.text = this.title
      }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
